import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { api, ApiError } from '../lib/api';
import { useAuth } from '../lib/auth';
import { useLang } from '../lib/i18n';
import { Avatar } from '../components/Avatar';
export function InviteAccept() {
    const { T, lang } = useLang();
    const { token } = useParams();
    const { user, refresh } = useAuth();
    const navigate = useNavigate();
    const [invite, setInvite] = useState(null);
    const [error, setError] = useState('');
    const [joining, setJoining] = useState(false);
    const [name, setName] = useState('');
    useEffect(() => {
        if (!token)
            return;
        (async () => {
            try {
                const r = await api.get(`/invites/${token}`);
                setInvite(r.invite);
            }
            catch (e) {
                setError(e instanceof ApiError ? e.message : String(e));
            }
        })();
    }, [token]);
    const accept = async () => {
        if (!token)
            return;
        setJoining(true);
        try {
            if (user) {
                // Already logged in — just join.
                const r = await api.post(`/invites/${token}/accept`);
                navigate(`/trips/${r.trip_id}`, { replace: true });
            }
            else {
                // First-time visitor: create guest account from invite in one step.
                const displayName = name.trim();
                if (!displayName) {
                    setError(T('請先填暱稱', '请先填昵称'));
                    setJoining(false);
                    return;
                }
                const r = await api.post(`/invites/${token}/claim`, { name: displayName });
                await refresh();
                navigate(`/trips/${r.trip_id}`, { replace: true });
            }
        }
        catch (e) {
            setError(e instanceof ApiError ? e.message : String(e));
            setJoining(false);
        }
    };
    if (error) {
        return (_jsx("div", { className: "tt-page", style: { maxWidth: 520 }, children: _jsxs("div", { className: "tt-card tt-section", children: [_jsx("h2", { style: { fontSize: 22 }, children: T('無法加入', '无法加入') }), _jsx("p", { style: { color: 'var(--ink-500)' }, children: error }), _jsx("a", { href: "/", className: "tt-btn ghost", style: { alignSelf: 'flex-start' }, children: T('回首頁', '回首页') })] }) }));
    }
    if (!invite)
        return _jsx("div", { className: "tt-load", children: T('載入中…', '加载中…') });
    return (_jsxs("div", { className: "tt-page", style: { maxWidth: 560 }, children: [_jsx("section", { className: "tt-cover", style: { background: invite.cover_color, minHeight: 180 }, children: _jsxs("div", { style: { position: 'relative', zIndex: 1 }, children: [_jsx("div", { style: { fontSize: 11, letterSpacing: '0.2em', opacity: 0.85, marginBottom: 10 }, children: "INVITATION" }), _jsx("h1", { style: { fontSize: 42 }, children: lang === 'cn' ? invite.title_cn : invite.title_tw }), _jsxs("div", { style: { fontSize: 14, opacity: 0.9 }, children: [lang === 'cn' ? invite.subtitle_cn : invite.subtitle_tw, invite.start_date && _jsxs(_Fragment, { children: [" \u00B7 ", invite.start_date, " \u2014 ", invite.end_date] })] })] }) }), _jsxs("div", { className: "tt-card tt-section", style: { marginTop: 20 }, children: [_jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: 12 }, children: [_jsx(Avatar, { name: invite.inviter_name, bg: invite.inviter_color, size: 40 }), _jsxs("div", { children: [_jsx("div", { style: { fontSize: 15, fontWeight: 500 }, children: invite.inviter_name }), _jsxs("div", { className: "tt-meta", style: { textTransform: 'none', letterSpacing: 0 }, children: [T('邀請你加入這趟行程', '邀请你加入这趟行程'), " \u00B7 ", invite.member_count, " ", T('位旅伴', '位旅伴')] })] })] }), !user && (_jsxs("div", { className: "tt-field", style: { marginTop: 16 }, children: [_jsx("label", { children: T('你的暱稱', '你的昵称') }), _jsx("input", { className: "tt-input", value: name, onChange: (e) => setName(e.target.value), placeholder: T('例：小美', '例：小美'), maxLength: 40, autoFocus: true }), _jsx("div", { className: "tt-meta", style: { marginTop: 6, letterSpacing: 0, textTransform: 'none' }, children: T('不需要 Email，只要填一個好認的名字。', '不需要 Email，只要填一个好认的名字。') })] })), _jsx("button", { className: "tt-btn primary", onClick: accept, disabled: joining || (!user && !name.trim()), style: { marginTop: 12 }, children: joining ? T('加入中…', '加入中…') : T('加入行程', '加入行程') })] })] }));
}
